class LineStateStatusType {
  None() {
    return 0;
  }
  Active() {
    return 'Active';
  }
  Expired() {
    return 'Expired';
  }
  Extended() {
    return 'Extended';
  }
  Canceled() {
    return 'Canceled';
  }
  SeparateFromPackage() {
    return 'SeparateFromPackage';
  }
  Archived() {
    return 'Archived';
  }
  RejectActivation() {
    return 'RejectActivation';
  }
  Cancelled(){
    return 'Cancelled'
  }
}
export default new LineStateStatusType();
